/* global toastr */
import React from 'react'
import { Link } from 'react-router-dom'
import { wrapView, request } from '../smart_bps/lib/utils'
import { stateToPropsSigur } from '../lib/stateToPropsSigur'
import { PROJECT_NAME } from './constants'
import { SigurModelView } from '../lib/SigurModelView'
import { Panel } from '../smart_bps/lib/components'

class ModelView extends SigurModelView {
  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      history: [],
    }
    this.loadHistory = this.loadHistory.bind(this)
  }

  componentDidMount() {
    super.componentDidMount?.()
    if (this.object_id && this.object_id !== 0) {
      this.loadHistory()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate?.(prevProps, prevState)
    if (this.object_id && this.object_id !== prevState.object_id) {
      this.loadHistory()
    }
  }

  canSeeAccessModesColumns() {
    const roles = this.props.user?.roles || []
    return roles.includes('admin') || roles.includes('approver')
  }

  loadHistory() {
    if (!this.object_id || this.object_id === 0) return
    request({
      method: 'get',
      url: `/api/granted_accesses/${this.object_id}/history`,
      success: (data) => {
        this.setState({ history: data.items || [] })
      },
      error: () => {
        this.setState({ history: [] })
      },
    })
  }

  /** Скрываем технические плейсхолдеры из формы */
  renderFormAttr(attr, horizontal) {
    if (attr.name === 'history_placeholder' || attr.name === 'people_main_placeholder') {
      return null
    }
    return super.renderFormAttr(attr, horizontal)
  }

  /** Вкладка «История доступов» — собственная таблица. */
  renderFormGroup(item, idx) {
    const tabTitle = item[0]
    if (tabTitle === 'История доступов') {
      if (this.state.selected_tab !== tabTitle) return null
      return (
        <div key={idx}>
          {this.renderHistoryTable()}
        </div>
      )
    }
    return super.renderFormGroup(item, idx)
  }

  /** На вкладке «Основное» под полями выводим таблицу «Текущие доступы». */
  renderFormGroupInclude(item, position) {
    const tabTitle = item[0]
    if (tabTitle === 'Основное' && position === 'bottom') {
      return <React.Fragment key="current_access">{this.renderCurrentAccessTable()}</React.Fragment>
    }
    return null
  }

  renderHistoryTable() {
    const { history } = this.state
    const showSensitive = this.canSeeAccessModesColumns()
    const colCount = showSensitive ? 8 : 6
    return (
      <div className="table-responsive card-body p-3" style={{ background: 'white' }}>
        <table className="table table-sm">
          <thead>
            <tr>
              <th style={{ maXwidth: '20%' }}>Цель посещения</th>
              <th>Место посещения</th>
              <th>К кому</th>
              <th>Начало действия</th>
              <th>Окончание действия</th>
              <th>Согласовывался в группе?</th>
              {showSensitive && <th>Режимы доступа</th>}
              {showSensitive && <th>Согласование</th>}
            </tr>
          </thead>
          <tbody>
            {history.length === 0 ? (
              <tr>
                <td colSpan={colCount} className="text-center text-muted">
                  Нет записей
                </td>
              </tr>
            ) : (
              history.map((row) => (
                <tr key={row.id}>
                  <td style={{overflowWrap: 'anywhere'}}>{row.visit_purpose || '—'}</td>
                  <td>{row.territory || '—'}</td>
                  <td>{row.to_user || '—'}</td>
                  <td>{row.start_datetime ? this.formatDateTime(row.start_datetime) : '—'}</td>
                  <td>{row.end_datetime ? this.formatDateTime(row.end_datetime) : '—'}</td>
                  <td>{row.object_group_name}</td>
                  {showSensitive && <td>{row.modes || '—'}</td>}
                  {showSensitive && (
                    <td>
                      {row.approval_id ? (
                        <Link to={`/approvals/${row.approval_id}/`}>#{row.approval_id}</Link>
                      ) : (
                        '—'
                      )}
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )
  }

  renderContentLeftActionLeftItems() {
    return super.renderContentLeftActionLeftItems().filter((action) => {
      if (action.key !== "save") return action
    })
  }

  renderInfo() {
    const {
      access_object_id,
      access_object_full_name,
      can_see_ao_link,
      organization_id,
      organization_title,
      can_see_org_link,
    } = this.state
    const isShowInfo = can_see_ao_link || can_see_org_link

    return isShowInfo ? (
      <Panel header="Информация" key="info_panel">
        <div className="card-text">
          {can_see_ao_link && (
            <div className="mb-2 sigur-info-block__row">
              <strong className='sigur-info-block__label'>Посетитель</strong> <Link to={`/access_objects/${access_object_id}/`}>{access_object_full_name}</Link>
            </div>
          )}
          {can_see_org_link && (
            <div className="mb-2 sigur-info-block__row">
              <strong className='sigur-info-block__label'>Контрагент</strong> <Link to={`/contractors/${organization_id}/`}>{organization_title}</Link>
            </div>
          )}
        </div>
      </Panel>
    ) : null
  }

  renderCurrentAccessTable() {
    const showSensitive = this.canSeeAccessModesColumns()
    const colCount = showSensitive ? 7 : 6
    const now = new Date()
    const active = (this.state.history || []).filter((row) => {
      if (!row.start_datetime || !row.end_datetime) return false
      const start = new Date(row.start_datetime)
      const end = new Date(row.end_datetime)
      return start <= now && now <= end
    })
    return (
      <Panel header="Текущие доступы" key="current_access_panel">
        <div className="table-responsive">
          <table className="table table-sm">
            <thead>
              <tr>
                <th className="text-wrap" style={{ maXwidth: '20%' }}>Цель посещения</th>
                <th>Место посещения</th>
                <th>К кому</th>
                <th>Начало действия</th>
                <th>Окончание действия</th>
                <th>Согласовывался в группе?</th>
                {showSensitive && <th>Режимы доступа</th>}
              </tr>
            </thead>
            <tbody>
              {active.length === 0 ? (
                <tr>
                  <td colSpan={colCount} className="text-center text-muted">
                    Нет действующих доступов
                  </td>
                </tr>
              ) : (
                active.map((row) => (
                  <tr key={row.id}>
                    <td>{row.visit_purpose || '—'}</td>
                    <td>{row.territory || '—'}</td>
                    <td>{row.to_user || '—'}</td>
                    <td>{row.start_datetime ? this.formatDateTime(row.start_datetime) : '—'}</td>
                    <td>{row.end_datetime ? this.formatDateTime(row.end_datetime) : '—'}</td>
                    <td>{row.object_group_name}</td>
                    {showSensitive && <td>{row.modes || '—'}</td>}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Panel>
    )
  }

  formatDateTime(value) {
    if (!value) return ''
    try {
      const d = new Date(value)
      if (Number.isNaN(d.getTime())) return value
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      return `${day}.${month}.${year} ${hours}:${minutes}`
    } catch (e) {
      return value
    }
  }
}

export default wrapView(ModelView, (state) => stateToPropsSigur(state, PROJECT_NAME))
